import { render, staticRenderFns } from "./EnumerationListsView.vue?vue&type=template&id=6d12ec44"
import script from "./EnumerationListsView.vue?vue&type=script&lang=ts"
export * from "./EnumerationListsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports